import * as React from "react"

const List = ({ className, children, columns }) => {
  let listStyle = ""

  if (columns === "2") {
    listStyle = "grid md:grid-cols-2 md:gap-x-4"
  }

  return (
    <ul
      className={`${className ? className : ""} ${listStyle ? listStyle : ""}`}
    >
      {children}
    </ul>
  )
}

export default List
